import { Wizard } from '../../../components/Wizard/Wizard';

import type { SofWizardStepsMapping } from './types';
import { initSofViewFactory } from './views/InitSofView/InitSofView';
import { sofIssueViewFactory } from './views/SofIssueView/SofIssueView';
import { sofProcessViewFactory } from './views/SofProcessView/SofProcessView';
import { sofSuccessViewFactory } from './views/SofSuccessView/SofSuccessView';

const stepFactories = [initSofViewFactory, sofProcessViewFactory, sofIssueViewFactory, sofSuccessViewFactory];
const stepsMapping: SofWizardStepsMapping = {
  init: stepFactories.indexOf(initSofViewFactory),
  process: stepFactories.indexOf(sofProcessViewFactory),
  issue: stepFactories.indexOf(sofIssueViewFactory),
  success: stepFactories.indexOf(sofSuccessViewFactory),
};
const steps = stepFactories.map((factory) => factory({ stepsMapping }));

export function SofReactionDialog() {
  return <Wizard redesign steps={steps} />;
}
